export default "__VITE_ASSET__CUPKN8jO__"